import { l as layout } from "./layout-store.js";
import { s as stopScroll, r as resumeScroll } from "./scrollControl.js";
import { d as debounce } from "./lodash-utils.js";
import "./preact-core.js";
class ShopifySearch extends HTMLElement {
  constructor() {
    var _a;
    super();
    this.searchFormSelector = ".shopify-search__form";
    this.searchInputSelector = ".shopify-search__input";
    this.predictiveWrapSelector = ".shopify-search__predictive-results-wrap";
    this.layout = layout;
    this.loading = false;
    this.resultsShow = true;
    this.cachedResults = [];
    this.predictiveResults = null;
    this.query = "";
    this.abortController = new AbortController();
    this.searchForm = this.querySelector(this.searchFormSelector);
    this.searchInput = this.querySelector(this.searchInputSelector);
    this.predictiveWrap = this.querySelector(this.predictiveWrapSelector);
    this.clearBtn = this.querySelector(".shopify-search__clear");
    (_a = this.clearBtn) == null ? void 0 : _a.addEventListener("click", (e) => {
      e.preventDefault();
      this.resetForm();
    });
    if (!this.searchForm || !this.searchInput || !this.predictiveWrap) {
      if (!this.searchForm) {
        console.error(
          `Shopify Search can't find form element ${this.searchFormSelector}`
        );
      }
      if (!this.searchInput) {
        console.error(
          `Shopify Search can't find form element ${this.searchInputSelector}`
        );
      }
      if (!this.predictiveWrap) {
        console.error(
          `Shopify Search can't find form element ${this.predictiveWrapSelector}`
        );
      }
      return;
    }
    document.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.layout.slideover = null;
    });
    if (this.dataset.lang == "en") {
      this.searchInput.addEventListener(
        "input",
        debounce(
          (e) => {
            e.preventDefault();
            this.handleChange(e);
          },
          100,
          {
            leading: false,
            trailing: true
          }
        ).bind(this)
      );
    }
  }
  getSearchResults(searchTerm) {
    this.loading = true;
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    if (this.cachedResults[queryKey]) {
      return;
    }
    if (searchTerm.length) {
      fetch(
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(
          searchTerm
        )}&section_id=predictive-search`,
        {
          signal: this.abortController.signal
        }
      ).then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.layout.slideover.value = null;
          throw error;
        }
        return response.text();
      }).then((results) => {
        this.predictiveResults = results;
        this.renderSearchResults();
      }).catch((error) => {
        if ((error == null ? void 0 : error.code) === 20) {
          return;
        }
        throw error;
      });
    } else {
      this.predictiveResults = null;
    }
  }
  renderSearchResults() {
    this.resultsShow = true;
    this.loading = false;
    if (this.query != "" && this.predictiveResults) {
      this.predictiveWrap.innerHTML = this.predictiveResults;
      document.querySelector(".global-header").classList.add("--search-open");
      stopScroll();
      this.clearBtn.classList.add("--active");
      this.predictiveWrap.classList.add("--active");
    } else {
      this.predictiveWrap.classList.remove("--active");
      setTimeout(() => {
        this.predictiveWrap.innerHTML = this.predictiveResults;
      }, 300);
    }
    if (this.query == "") {
      document.querySelector(".global-header").classList.remove("--search-open");
      resumeScroll();
      this.clearBtn.classList.remove("--active");
      this.predictiveWrap.classList.remove("--active");
      setTimeout(() => {
        this.predictiveWrap.innerHTML = this.predictiveResults;
      }, 300);
    }
  }
  handleChange(event) {
    this.query = this.searchInput.value;
    this.getSearchResults(this.query);
  }
  resetForm() {
    this.query = "";
    this.searchInput.value = "";
    this.predictiveResults = null;
    this.renderSearchResults();
  }
}
if (!customElements.get("shopify-search")) {
  customElements.define("shopify-search", ShopifySearch);
}
export {
  ShopifySearch,
  ShopifySearch as default
};
